module.exports = __webpack_public_path__ + "media/images/project/projects-bbedeac51762c8ded4682d816a963d5e.svg";